<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="setWeekNumberQueryAndSubmitFilters"
  >
    <template #title> جلسات رزرو شده شما </template>

    <template #titleBtn>
      <BButton variant="success" @click="renderChangeUserLinkDialog">
        ویرایش لینک جلسه فعلی
      </BButton>
    </template>
    <template #filters>
      <WeekNumberPicker class="w-24 filters-width" v-model="weekNumber">
      </WeekNumberPicker>
    </template>
    <CustomTable
      :pageNumber="pageNumber"
      :count="count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="pendingScheduleList"
      :cellClass="() => 'custom-active-schedules-table-cells-padding'"
      @changePage="changePage"
      :rowClass="customRowClass"
    >
      <template #lessonTitle="data">
        <div class="text-center w-100">
          <template v-if="data.item.lessonTitle">
            {{ data.item.lessonTitle }}
          </template>
          <template v-else>-</template>
        </div>
      </template>
      <template #studentFullName="data">
        <b-link :to="`/master/users/${data.item.studentUserId}`">
          {{ data.item.studentFullName }}
        </b-link>
      </template>

      <template #studentWhatsapp="data">
        <template v-if="data.item.whatsAppLink">
          <BButton
            variant="transparent"
            target="_blank"
            :href="whatsappDesktopLinkGenerator(data.item.whatsAppLink)"
            class="d-lg-block d-none"
          >
            <WhatsappIcon />
          </BButton>
          <BButton
            variant="transparent"
            target="_blank"
            :href="whatsappMobileLinkGenerator(data.item.whatsAppLink)"
            class="d-block d-lg-none"
          >
            <WhatsappIcon />
          </BButton>
        </template>
        <template v-else>-</template>
      </template>
      <template #startDate="data">
        <div class="w-100 d-flex flex-column flex-md-row">
          <p class="mb-0 mr-1" style="white-space: nowrap">
            {{
              new Date(data.item.startDate).toLocaleDateString("fa-IR", {
                weekday: "long",
              })
            }}
          </p>
          <p class="mb-0 mr-1" style="white-space: nowrap">
            {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
          </p>
          <p class="mb-0" style="white-space: nowrap">
            از ساعت :
            {{
              new Date(`${data.item.startDate}`).toLocaleTimeString("fa-IR", {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </p>
          <p class="mb-0" style="white-space: nowrap">
            تا ساعت :
            {{
              new Date(`${data.item.endDate}`).toLocaleTimeString("fa-IR", {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </p>
        </div>
      </template>
      <template #actions="data">
        <div
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <b-link
            style="white-space: nowrap"
            v-for="schedule in data.item.scheduleId"
            :key="schedule.scheduleId"
            class="my-1"
            :to="`/master/reserved/${schedule.scheduleId}`"
          >
            شروع جلسه برای ساعت
            {{
              new Date(schedule.startDate).toLocaleTimeString("fa-IR", {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
            -
            {{
              new Date(schedule.endDate).toLocaleTimeString("fa-IR", {
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </b-link>
        </div>
      </template>
    </CustomTable>
    <UpdateScheduleLinkDialog></UpdateScheduleLinkDialog>
  </PageWrapper>
</template>
<script>
import { GetAllSchedulesForMaster } from "@/libs/Api/Schedules";
export default {
  mounted() {
    if (this.computedWeekNumberRouteQuery) {
      this.weekNumber = this.computedWeekNumberRouteQuery;
    }
    //  else {
    //   this.weekNumber = 0;
    // }
    this.getAllScheduledSessions();
    // this.getThisWeekSchedules();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllScheduledSessions();
      },
    },
    targetDate: {
      handler(val) {
        this.getAllScheduledSessions();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      targetDate: null,
      weekNumber: 1,
      // prevWeek: 0,
      pendingScheduleList: null,
      myTableColumns: [
        {
          key: "studentFullName",
          label: "نام زبان آموز",
        },
        // {
        //   key: "studentMobile",
        //   label: "شماره همراه زبان آموز",
        // },
        {
          key: "studentWhatsapp",
          label: "لینک واتس‌اپ",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
        },
        {
          key: "priceCategoryTitle",
          label: "گروه‌بندی",
        },
        {
          key: "lessonTitle",
          label: "نام درس",
        },
        {
          key: "actions",
          label: "جزئیات آزمون",
        },
      ],
    };
  },
  methods: {
    setWeekNumberQueryAndSubmitFilters() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          weekNumber: this.weekNumber,
        },
      });
      this.getAllScheduledSessions();
    },
    customRowClass(row) {
      if (!row.isSeen) {
        return "bg-danger";
      }
      console.log(row);
    },
    changePage(pageNumber) {
      this.pageNumber = pageNumber;
    },
    renderChangeUserLinkDialog() {
      this.$bvModal.show("change-user-link-dialog");
    },
    whatsappDesktopLinkGenerator(mobile) {
      return `https://web.whatsapp.com/send?phone=${mobile ? mobile : ""}`;
    },
    whatsappMobileLinkGenerator(mobile) {
      return `https://api.whatsapp.com/send?phone=${mobile ? mobile : ""}`;
    },
    clearDateFilter() {
      this.actionsListFilter.createDate = null;
    },
    createJalaliDate(date) {
      if (date) {
        const myCustomDate = new Date(date).toLocaleDateString("fa-IR");
        return myCustomDate;
      } else {
        return null;
      }
    },
    async getAllScheduledSessions() {
      try {
        this.isLoading = true;
        let qParams = {
          count: this.count,
          pageNumber: this.pageNumber,
          status: 1,
        };
        if (this.weekNumber) {
          qParams["weekNumber"] = this.weekNumber;
        }
        let _this = this;
        let getAllSchedulesForMaster = new GetAllSchedulesForMaster(_this);
        getAllSchedulesForMaster.setRequestParam(qParams);
        await getAllSchedulesForMaster.fetch((response) => {
          if (response.isSuccess) {
            _this.pendingScheduleList = response.data.schedules;
            _this.totalCount = response.data.schedulesCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    fromDateToday() {
      let today = new Date(Date.now());
      today = new Date(today).setUTCHours(0, 0, 0);
      return new Date(today);
    },
    toDateTonight() {
      let tonight = new Date(Date.now());
      tonight = new Date(tonight).setUTCHours(23, 59, 59);
      return new Date(tonight);
    },
    computedWeekNumberRouteQuery() {
      if (this.$route.query && this.$route.query.weekNumber) {
        return this.$route.query.weekNumber;
      }
      return null;
    },
  },
  components: {
    BButton,
    BLink,
    WhatsappIcon,
    PageWrapper,
    CustomTable,
    WeekAgoPicker,
    WeekNumberPicker,
    UpdateScheduleLinkDialog,
  },
};
import WhatsappIcon from "@/views/components/Icons/WhatsappIcon.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import WeekAgoPicker from "@/views/components/MasterSchedule/WeekAgoPicker.vue";
import WeekNumberPicker from "@/views/components/MasterSchedule/WeekNumberPicker.vue";
import UpdateScheduleLinkDialog from "@/views/components/MasterSchedule/UpdateScheduleLinkDialog.vue";
import { BButton, BLink } from "bootstrap-vue";
</script>
<style>
.custom-active-schedules-table-cells-padding {
  padding: 0.5rem !important;
  text-align: center !important;
}
</style>
